/** @format */

const VisualStatistics = () => {
  return <>Visual Statistics</>
}

export default VisualStatistics
